import React from "react"
import { getThemeStylesheet } from "../utils/filters/build"
import TailwindProvider from "../../../../shared/providers/TailwindProvider"
import Maintenance from "../../../../shared/Layouts/Maintenance"
import SearchTabs from "../../../../shared/components/SearchTabs"

// default, travelon

const RootLayout = ({ children, themeName, isAdmin, activeTab }) => {
  const theme = getThemeStylesheet(themeName)

  return (
    // <TailwindProvider>
    //   {isAdmin ? (
    //     <div data-theme={theme} className="w-full max-w-[1350px] mx-auto">
    //       {children}
    //     </div>
    //   ) : (
    //     <Maintenance />
    //   )}
    // </TailwindProvider>
    <>
      {/* {isAdmin ? ( */}
      <div data-theme={theme} className="w-full max-w-[1350px] mx-auto">
        <SearchTabs active={activeTab} />
        {children}
      </div>
      {/* ) : (
        <Maintenance />
      )} */}
    </>
  )
}

export default RootLayout
